export const apiConfig = {
  rest: {
    // url: 'https://dev-govj-wp-gw.klefki.io/scooby-iam',
    url: 'http://localhost:3802',
    // url: 'https://staging-govj-wp-gw.klefki.io/scooby-iam',
  },
  gql: {
    url: 'http://localhost:3801',
    // url: 'https://dev-govj-wp-gw.klefki.io/scooby-gql',
    // url: 'https://staging-govj-wp-gw.klefki.io/graphql',
  },
};
